import { EntityState } from '@ngrx/entity';
import { Employee } from '@app/resources/services';

export interface EmployeeState extends EntityState<Employee> {
  selectedEmployeeId: number | null;
  hasLoaded: boolean;
}
